import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "react-html5-camera-photo/build/css/index.css";
import { EnforcementActions, SuperAdminAction } from "../../Actions";
import { connect } from "react-redux";
import Loader from "../Loader/Loader";
import CustomContentAlert from "../helper";
import audioFileNotAllowed from "../../../assets/sound/NotAllowed.mp3";
import audioFileAllowed from "../../../assets/sound/Allowed.wav";
import Webcam from "react-webcam";
class PhotoVerifyRemote extends Component {
  constructor(_props) {
    super();
    this.state = {
      selectedProperty: "",
      image: "",
      isOpenCamera: true,
      loader: false,
      show_error: false,
      api_error_message: "",
      playSound: false,
      cameraError: "",
      property_name: "",
      lot_name: "",
      selectedStall: null,
      lpnnumber: "",
      status: "",
    };
    this.webcamRef = React.createRef();
  }

  componentDidMount = async () => {
    const useThis = this;
    if (this.props.location?.search) {
      const prop = this.props.location.search.split("&&")[0];
      const propertyId = prop.replace("?property_id=", "");
      const data = this.props.location.search.split("&&")[1];
      const lotId = data.replace("lot_id=", "");
      const result = await this.props.getPropertyNameById(propertyId);
      const lotResult = await this.props.getLotNameById(lotId);
      if (result && lotResult) {
        this.setState({
          property_name: result.site_name,
          selectedProperty: propertyId,
          lot_name: lotResult.alias,
          selectedLot: lotId,
        });
      }
      document.addEventListener("click", function (event) {
        if (event.target.id !== "scanPlateButton") {
          if (useThis.state.isOpenCamera) {
            useThis.handleTakePhoto();
          } else {
            useThis.setState({ isOpenCamera: true, lpnnumber: "", status: "" });
          }
        }
      });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("click");
  };

  handleTakePhoto = async () => {
    if (this.webcamRef?.current) {
      const imageURL = this.webcamRef.current.getScreenshot();
      console.log("----imag", imageURL);
      const x = this.dataURLtoFile(imageURL);
      console.log("----x", x);
      const form_data = new FormData();
      form_data.append("lot_id", this.state.selectedLot);
      let stall_id;
      if (!this.state.selectedStall) {
        stall_id = null;
      } else {
        stall_id = this.state.selectedStall;
      }
      form_data.append("stall_id", stall_id);
      form_data.append("property_id", this.state.selectedProperty);
      form_data.append("files", x);
      this.setState(
        {
          loader: true,
        },
        async () => {
          await this.props.scanPlate(form_data);
          if (this.props.api_response) {
            if (this.props.plateCheckData?.isPlateApproved) {
              this.setState({
                status: "Approved",
                lpnnumber: this.props.plateCheckData?.lpn,
                loader: false,
                isOpenCamera: false,
                verified: true,
                image: imageURL,
              });
            } else {
              this.setState({
                status: "Not Approved",
                lpnnumber: this.props.plateCheckData?.lpn,
                loader: false,
                isOpenCamera: false,
                verified: false,
                image: imageURL,
              });
            }
          } else {
            this.setState({
              loader: false,
              isOpenCamera: false,
              show_error: true,
              api_error_message: "Scan failed, please scan again or enter manually",
              verified: false,
              playSound: true,
              image: "",
              status: "",
              lpnnumber: "",
            });
            setTimeout(() => {
              this.setState({ show_error: false, playSound: false });
            }, 4000);
          }
        },
      );
    }
  };

  dataURLtoFile = (dataurl) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], "lpn.png", { type: mime });
  };

  handleCameraError = (error) => {
    console.log("error", error);
    this.setState({
      cameraError: "Permission Denied",
    });
  };

  render() {
    const videoConstraints = {
      width: 1280,
      height: 720,
      facingMode: "environment",
    };
    const { image, isOpenCamera, loader, show_error, api_error_message, verified, playSound } = this.state;
    return (
      <div>
        <Container className="scan-container">
          <Row>
            <Col>
              {playSound && (
                <div>
                  <audio id="audio" style={{ display: "none" }} controls autoPlay={true} preload>
                    <source src={verified ? audioFileAllowed : audioFileNotAllowed}></source>
                  </audio>
                </div>
              )}
              {loader && (
                <div className="loader">
                  <Loader />
                </div>
              )}
              {!loader && (
                <>
                  <Row className="justify-content-center">
                    <Col lg="6" md="8" sm="12" className="pr-md-1 center scanned-image mt-2 mb-2">
                      <div className="scanner-corners">
                        <div className="top left"></div>
                        <div className="top right"></div>
                        <div className="bottom right"></div>
                        <div className="bottom left"></div>
                        {isOpenCamera && (
                          <div>
                            <Webcam
                              audio={false}
                              height={720}
                              ref={this.webcamRef}
                              screenshotFormat="image/jpeg"
                              width={1280}
                              videoConstraints={videoConstraints}
                            />
                          </div>
                        )}
                        {!isOpenCamera && (
                          <img
                            src={
                              image
                                ? this.state.image
                                : "https://cdn.centralwire.com/wp-content/uploads/2021/02/IndustryIcons_automotive.png?strip=all&lossy=1&w=2560&ssl=1"
                            }
                            alt=""
                            className="image-preview"
                            accept="image/*"
                          />
                        )}
                      </div>
                    </Col>
                    {isOpenCamera && (
                      <Col xs={12} className="d-flex justify-content-center">
                        <button onClick={() => this.handleTakePhoto()} className="text-nowrap capture-photo-button w-100">
                          Capture photo
                        </button>
                      </Col>
                    )}
                  </Row>
                  <Row className="justify-content-center">
                    <Col xl="6">
                      <Row>
                        <Col xs="12">
                          <div id="scanPlateButton"></div>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl="12" className="scan-photo-field">
                      <Row className="justify-content-center mt-1">
                        <Col xl="6">
                          <Row>
                            <Col xs="6">
                              <p className="mb-1">Property Name : {this.state.property_name} </p>
                            </Col>
                            <Col xs="6">
                              <p className="mb-1">Lot Name : {this.state.lot_name}</p>
                            </Col>
                            <Col xs="6">
                              <p className="mb-1 mr-2">Plate No. : {this.state.lpnnumber}</p>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="12">
                              <p className="mb-1 d-flex align-items-center">
                                <span className="mr-2">Status : </span>
                                {this.state.status === "Approved" && (
                                  <>
                                    <Approved />
                                    <span className="ml-2 text-success font-weight-600 font-size-25"> {this.state.status} </span>
                                  </>
                                )}
                                {this.state.status === "Not Approved" && (
                                  <>
                                    <Rejected />
                                    <span className="ml-2 text-danger font-weight-600 font-size-25"> {this.state.status} </span>
                                  </>
                                )}
                              </p>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </>
              )}
              {show_error && <CustomContentAlert delay={4000} message={api_error_message} className="toast-error" />}
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ APIResponseDetails, EnforcementDetails }) => {
  const { api_response, api_error_message, api_success_message } = APIResponseDetails;
  const { plateCheckData, extractedPlateNumber } = EnforcementDetails;
  return {
    api_response,
    api_error_message,
    api_success_message,
    plateCheckData,
    extractedPlateNumber,
  };
};

const mapStateToDispatch = {
  scanPlate: EnforcementActions.scanPlateForGoogleGlass,
  getPropertyNameById: SuperAdminAction.getPropertyNameById,
  getLotNameById: SuperAdminAction.getLotNameById,
};

export default connect(mapStateToProps, mapStateToDispatch)(PhotoVerifyRemote);

export const Approved = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.9946 11.0623C24.9946 11.6887 24.9946 12.3151 24.9946 12.9352C24.9383 12.9603 24.9508 13.0104 24.9508 13.0542C24.9132 13.5115 24.8443 13.9688 24.7566 14.4198C23.3913 21.1285 16.6085 25.3442 9.95726 23.6091C3.80077 22.0055 -0.0509543 15.7916 1.24548 9.56516C2.26634 4.63538 6.24332 0.889491 11.2474 0.12528C11.5167 0.0814323 11.7986 0.100224 12.0616 0C12.6691 0 13.2829 0 13.8904 0C13.9029 0.0501122 13.9468 0.0438481 13.9843 0.0438481C15.7505 0.181657 17.4164 0.676514 18.9383 1.57853C22.2577 3.54544 24.2431 6.43315 24.8694 10.2479C24.9132 10.5173 24.8944 10.7992 24.9946 11.0623ZM21.2995 8.18081C21.2744 7.60452 20.9738 7.09714 20.36 6.82778C19.7212 6.5459 19.12 6.64613 18.6001 7.12219C17.6607 7.98036 16.7338 8.85106 15.8006 9.72176C14.1347 11.2752 12.4562 12.8412 10.7902 14.4072C10.6337 14.5513 10.5585 14.5764 10.4019 14.401C9.36854 13.2735 8.31636 12.1585 7.27045 11.0372C6.88841 10.63 6.43121 10.4108 5.87381 10.4672C5.2162 10.5361 4.75274 10.8931 4.52727 11.5133C4.3018 12.1459 4.45212 12.7097 4.90305 13.1983C6.68799 15.1088 8.4792 17.0193 10.2579 18.9361C10.3894 19.0739 10.452 19.0865 10.5961 18.9487C12.0992 17.5393 13.6148 16.1361 15.1179 14.733C16.9906 12.9853 18.8632 11.2314 20.7358 9.48373C21.1053 9.16426 21.2995 8.76337 21.2995 8.18081Z"
        fill="#00B900"
      />
    </svg>
  );
};

export const Rejected = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.3 11.109C24.3 11.7186 24.3 12.3283 24.3 12.9379C24.211 13.1583 24.225 13.3927 24.1922 13.6178C23.8454 16.0328 22.8797 18.1618 21.2485 19.9766C19.3219 22.1196 16.9313 23.4232 14.0813 23.8687C13.786 23.9156 13.4813 23.9015 13.1907 24C12.5813 24 11.9719 24 11.3625 24C11.3204 23.9297 11.25 23.9578 11.1938 23.9531C10.7344 23.9062 10.2797 23.8406 9.82974 23.7468C7.53755 23.2544 5.55005 22.1899 3.8813 20.5393C1.99224 18.6682 0.843799 16.4174 0.431299 13.7819C0.389111 13.5006 0.398486 13.2098 0.300049 12.9379C0.300049 12.2954 0.300049 11.6577 0.300049 11.0152C0.412549 10.7057 0.398486 10.3775 0.450049 10.0586C0.876611 7.58734 1.94536 5.44431 3.69849 3.6483C5.57817 1.72098 7.85161 0.548651 10.5188 0.131301C10.8 0.0890967 11.0907 0.098476 11.3625 0C11.9719 0 12.5813 0 13.1907 0C13.2188 0.056272 13.2704 0.0422051 13.3125 0.0422051C15.1547 0.192264 16.8797 0.731535 18.4454 1.70223C21.6375 3.68112 23.5547 6.52286 24.1641 10.2415C24.2204 10.5322 24.2063 10.8277 24.3 11.109ZM8.57349 7.29191C8.40474 7.2966 8.2313 7.3388 8.07661 7.43728C7.50942 7.78898 7.42974 8.53458 7.92192 9.02696C8.85005 9.96483 9.78286 10.898 10.725 11.8265C10.8797 11.9766 10.861 12.0516 10.7204 12.1876C10.2188 12.6706 9.73599 13.1676 9.2438 13.66C8.79849 14.1055 8.34849 14.551 7.90317 15.0012C7.60317 15.3107 7.5188 15.6811 7.67349 16.0797C7.82817 16.4736 8.13286 16.6846 8.55474 16.7081C8.88755 16.7315 9.15474 16.5815 9.38442 16.347C10.3079 15.4185 11.2407 14.49 12.1641 13.5615C12.2766 13.449 12.3422 13.4349 12.4594 13.5569C12.9563 14.068 13.4625 14.5651 13.9641 15.0668C14.4188 15.5217 14.8641 15.9766 15.3235 16.422C15.6516 16.7409 16.125 16.7972 16.5141 16.5815C16.8844 16.3798 17.0766 15.9625 17.0063 15.5264C16.9641 15.2732 16.8235 15.0856 16.6454 14.9121C15.7313 14.0023 14.8266 13.0832 13.9079 12.1829C13.7485 12.0281 13.7672 11.9437 13.9172 11.803C14.3579 11.381 14.7797 10.9449 15.211 10.5135C15.7125 10.0117 16.2235 9.51465 16.7157 9.00352C17.1516 8.55334 17.1188 7.89215 16.6594 7.51231C16.2563 7.17468 15.6844 7.21219 15.2813 7.61078C14.3438 8.53927 13.411 9.47245 12.4829 10.415C12.3469 10.5557 12.2766 10.5557 12.1407 10.415C11.2266 9.48652 10.2985 8.56741 9.37974 7.64361C9.15474 7.4279 8.9063 7.29191 8.57349 7.29191Z"
        fill="#F34336"
      />
    </svg>
  );
};
